import type { InventorySourceOrigin } from '@/shared/inventoryTabSources';
import type { ResolvedOrigin } from '@/shared/reportDataSources';

// The note shown when a saved data source choice is partly or fully
// disconnected (FIG-409 · UC-233/234). Shared by Settings › Data sources and
// the read-only "Data source: …" lines, so the wording stays the same.
export function missingSourceNote(origin: ResolvedOrigin, missingCount: number): string | null {
  if (origin === 'fallback') {
    return missingCount > 1
      ? 'None of the saved sources are connected any more, so the default is used.'
      : 'The saved source is no longer connected, so the default is used.';
  }
  if (missingCount === 1) return '1 saved source is no longer connected and is left out.';
  if (missingCount > 1) return `${missingCount} saved sources are no longer connected and are left out.`;
  return null;
}

// The note for a saved Inventory source that is no longer connected (FIG-442 ·
// D12). The Inventory tab and the Settings row show every connection instead of
// nothing, and say so with this wording.
export function missingInventorySourceNote(origin: InventorySourceOrigin): string | null {
  return origin === 'fallback'
    ? "The saved source is no longer connected, so each connection's own stock is used."
    : null;
}
